import { render } from "./ZoomImage.vue?vue&type=template&id=42801de5"
import script from "./ZoomImage.vue?vue&type=script&lang=js"
export * from "./ZoomImage.vue?vue&type=script&lang=js"

import "./ZoomImage.vue?vue&type=style&index=0&id=42801de5&lang=stylus"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__